import { FeatureResponse } from '../../client';
import { Money } from '../atoms';

interface InitiativeProps {
  feature: Pick<FeatureResponse, 'id' | 'earnings_rate'>;
}

export function Initiative({ feature }: InitiativeProps) {
  return (
    <div className="p-3 flex items-center justify-center">
      <div className="flex flex-col items-center gap-1">
        <span className="text-lg font-bold">{feature.id}</span>
        <span className="flex items-center gap-1">
          <Money colorScheme="light">{feature.earnings_rate}</Money>
          <samp className="text-xs">/sec</samp>
        </span>
      </div>
    </div>
  );
}
